import React from 'react';
import Styles from './bar-score-styles.scss';
const BarScore = ({ score }) => {
    const getStateByScore = (score) => {
        const scoreRanges = [
            { state: 'poor', minScore: 300, maxScore: 579 },
            { state: 'fair', minScore: 580, maxScore: 669 },
            { state: 'good', minScore: 670, maxScore: 739 },
            { state: 'veryGood', minScore: 740, maxScore: 799 },
            { state: 'excellent', minScore: 800, maxScore: 850 }
        ];
        const scoreRange = scoreRanges.find(range => score >= range.minScore && score <= range.maxScore);
        if (scoreRange) {
            return scoreRange.state;
        }
        return 'excellent';
    };
    return (React.createElement("div", { className: Styles.barScoreCont },
        React.createElement("div", { className: Styles.poor },
            React.createElement("span", { className: Styles.text }, "Poor"),
            React.createElement("span", { className: Styles.start }, "300"),
            React.createElement("span", { className: Styles.end }, "580"),
            React.createElement("span", { className: Styles.active, style: {
                    backgroundColor: getStateByScore(score) === 'poor' ? '#00A3FF' : '#F04A4A1A'
                } })),
        React.createElement("div", { className: Styles.fair },
            React.createElement("span", { className: Styles.text }, "Fair"),
            React.createElement("span", { className: Styles.end }, "670"),
            React.createElement("span", { className: Styles.active, style: {
                    backgroundColor: getStateByScore(score) === 'fair' ? '#00A3FF' : '#F482181A'
                } })),
        React.createElement("div", { className: Styles.good },
            React.createElement("span", { className: Styles.text }, "Good"),
            React.createElement("span", { className: Styles.end }, "740"),
            React.createElement("span", { className: Styles.active, style: {
                    backgroundColor: getStateByScore(score) === 'good' ? '#00A3FF' : '#FFB8001A'
                } })),
        React.createElement("div", { className: Styles.veryGood },
            React.createElement("span", { className: Styles.text }, "Very Good"),
            React.createElement("span", { className: Styles.end }, "800"),
            React.createElement("span", { className: Styles.active, style: {
                    backgroundColor: getStateByScore(score) === 'veryGood' ? '#00A3FF' : 'rgba(133,203,130,0.10)'
                } })),
        React.createElement("div", { className: Styles.excellent },
            React.createElement("span", { className: Styles.text }, "Excellent"),
            React.createElement("span", { className: Styles.end }, "850"),
            React.createElement("span", { className: Styles.active, style: {
                    backgroundColor: getStateByScore(score) === 'excellent' ? '#00A3FF' : '#65C7021A'
                } }))));
};
export default BarScore;
